export const GET_KINDERGARTEN_TARGET_GROUPS = 'GET_KINDERGARTEN_TARGET_GROUPS';
export const SET_KINDERGARTEN_TARGET_GROUPS = 'SET_KINDERGARTEN_TARGET_GROUPS';
export const SAVE_KINDERGARTEN_TARGET_GROUP = 'SAVE_KINDERGARTEN_TARGET_GROUP';
export const ADD_KINDERGARTEN_TARGET_GROUP = 'ADD_KINDERGARTEN_TARGET_GROUP';
export const RESET_TARGET_GROUP_STORE = 'RESET_TARGETGROUP_STORE';
export const GET_KINDERGARTEN_TARGET_GROUP = 'GET_KINDERGARTEN_TARGET_GROUP';
export const UPDATE_KINDERGARTEN_TARGET_GROUP = 'UPDATE_KINDERGARTEN_TARGET_GROUP';
export const SET_KINDERGARTEN_TARGET_GROUP = 'SET_KINDERGARTEN_TARGET_GROUP';